import {
  ComponentBuilder,
  FunctionComponent
} from '../../component-builder/types';
import { DisplayConfigType } from 'formats/display/lib/config';
import { Component } from './component';

const isArrowPriority = (formatConfig: DisplayConfigType) => {
  return Object.keys(formatConfig?.brand || {}).length > 0
    ? formatConfig.brandOrArrowPriority === 'arrowOverBrand'
    : true;
};

export class ArrowButtonBuilder implements ComponentBuilder<DisplayConfigType> {
  isInjectable(adContext: AdContext, formatConfig: DisplayConfigType): boolean {
    return formatConfig?.useArrowBtn && isArrowPriority(formatConfig);
  }

  build(
    adContext: AdContext,
    formatConfig: DisplayConfigType
  ): FunctionComponent {
    return Component;
  }
}
